"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppealTitleWithManagementMenu = exports.AppealManagementMenu = exports.AppealTitle = void 0;
const adaptivecards_1 = require("adaptivecards");
const __1 = require("../..");
const ImageCardUrl_1 = require("../constants/ImageCardUrl");
const CardHelper_1 = require("../utils/CardHelper");
function AppealTitle(survey) {
    return CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: (0, CardHelper_1.getSurveyTitleDisplay)(survey),
        wrap: true,
        weight: adaptivecards_1.TextWeight.Bolder,
        size: adaptivecards_1.TextSize.Large,
    });
}
exports.AppealTitle = AppealTitle;
function AppealManagementMenu(survey) {
    return CardHelper_1.CardHelper.create(adaptivecards_1.Image, {
        url: ImageCardUrl_1.SharedImageCardUrl.OVERFLOW_URL,
        pixelWidth: 15,
        selectAction: CardHelper_1.CardHelper.create(adaptivecards_1.SubmitAction, {
            title: "...",
            data: (0, __1.SurveyManagementMenuCommand)(survey.id).toTaskFetchCommand(),
        }),
    });
}
exports.AppealManagementMenu = AppealManagementMenu;
function AppealTitleWithManagementMenu(survey) {
    const headerColumns = new adaptivecards_1.ColumnSet();
    const leftColumn = CardHelper_1.CardHelper.create(adaptivecards_1.Column, { width: "stretch" });
    leftColumn.addItem(AppealTitle(survey));
    headerColumns.addColumn(leftColumn);
    if (survey.id) {
        const rightColumn = CardHelper_1.CardHelper.create(adaptivecards_1.Column, {
            width: "auto",
            verticalContentAlignment: adaptivecards_1.VerticalAlignment.Center,
        });
        rightColumn.addItem(AppealManagementMenu(survey));
        headerColumns.addColumn(rightColumn);
    }
    return headerColumns;
}
exports.AppealTitleWithManagementMenu = AppealTitleWithManagementMenu;
//# sourceMappingURL=AppealTitle.js.map